<!-- The root-filter component handles his own visibility (depending on brand, route, etc.) -->
<app-root-filter></app-root-filter>
@if (selectedOption !== 3) {
    <fuse-app-lessons-tab class="page-layout simple inner-scroll"
                          fxFlex
                          type="byRole"
                          [creatorsRolesFilter]="creatorsRolesFilter"
                          [selectedOption]="selectedOption">
    </fuse-app-lessons-tab>
}

@if (selectedOption === 3) {
    <app-iackathon-wrapper [autoFold]="true"></app-iackathon-wrapper>
}